import { createFeatureSelector, createSelector, MemoizedSelector, select } from '@ngrx/store';
import { StoreState } from '../../interfaces/store-interfaces';
import { StoreModel } from '../../interfaces/store-interfaces';

// Selector to retrieve the feature state
export const selectStoreState: MemoizedSelector<object, StoreState> = createFeatureSelector<StoreState>('store');

// Selector to retrieve all stores
export const selectAllStores: MemoizedSelector<object, StoreModel[]> = createSelector(
  selectStoreState,
  (state: StoreState) => state.stores
);

// Selector to retrieve the loading state
export const selectLoading: MemoizedSelector<object, boolean> = createSelector(selectStoreState, (state: StoreState) => state.loading);

// Selector to retrieve the error state
export const selectError: MemoizedSelector<object, string | null> = createSelector(selectStoreState, (state: StoreState) => state.error);

// Selector to retrieve the initialized state
export const selectStoresInitialized: MemoizedSelector<object, boolean> = createSelector(
  selectStoreState,
  (state: StoreState) => state.initialized
);

export const selectSelectedStore: MemoizedSelector<object, StoreModel | null> = createSelector(
  selectStoreState,
  (state: StoreState) => state.selectedStore
);
